import { createStatisticAPIClient } from '@api/BffAPIClientFactory'
import { LoadState } from '@util/types'
import { Statistics } from '@/generated-clients/bff'
import StatisticFrequency from '@/models/statistic/StatisticFrequency'
import StatisticAttribute from '@/models/statistic/StatisticAttribute'

// eslint-disable-next-line no-unused-vars
const statisticApiClient = createStatisticAPIClient()

function createState () {
  return {
    statistics: {
      status: LoadState.None,
      response: {
        statisticTabs: {
          keyData: {
            summary: {
              tripCount: null,
              duration: null,
              distance: null
            },
            averages: {},
            highlights: []
          }
        }
      } as Statistics,
      filter: {}
    },
    averageSelection: 'perTrip' as StatisticFrequency,
    diagramSelections: ['tripCount', 'tripCount', 'tripCount', 'tripCount', 'tripCount', 'tripCount'] as StatisticAttribute[],
    timelineSelection: {
      frequency: 'daily' as StatisticFrequency,
      attribute: 'tripCount' as StatisticAttribute
    }
  }
}

function equalFilters (filter, other) {
  return filter.from === other.from && filter.until === other.until && filter.vehicleId === other.vehicleId
}

export default {
  namespaced: true,

  state: createState,

  mutations: {
    STATISTICS_REQUEST (state, filter) {
      state.statistics.status = LoadState.Loading
      state.statistics.filter = filter
    },
    STATISTICS_RESPONSE (state, payload) {
      state.statistics.status = LoadState.Success
      state.statistics.response = payload
    },
    STATISTICS_ERROR_RESPONSE (state, payload) {
      state.statistics.status = LoadState.Error
      state.statistics.response = payload
    },
    RESET_STATISTICS (state) {
      state.statistics.status = LoadState.None
      state.statistics.response = {}
      state.statistics.filter = {}
    },
    SET_AVERAGE_SELECTION (state, payload) {
      state.averageSelection = payload
    },
    SET_DIAGRAM_SELECTION (state, { index, selection }) {
      state.diagramSelections = state.diagramSelections.map((value, idx) => idx === index ? selection : value)
    },
    SET_TIMELINE_FREQUENCY_SELECTION (state, payload) {
      state.timelineSelection = {
        frequency: payload,
        attribute: state.timelineSelection.attribute
      }
    },
    SET_TIMELINE_ATTRIBUTE_SELECTION (state, payload) {
      state.timelineSelection = {
        frequency: state.timelineSelection.frequency,
        attribute: payload
      }
    }
  },

  actions: {
    fetchStatistics ({ commit, state }, { vehicleId, datePeriod, from, until, smartConnectInfo }) {
      const filter = { vehicleId, datePeriod, from, until }

      if (state.statistics.status === LoadState.Success && equalFilters(state.statistics.filter, filter)) {
        return Promise.resolve(state.statistics.response)
      }

      commit('STATISTICS_REQUEST', filter)
      return new Promise((resolve, reject) => {
        statisticApiClient
          .getStatistics(from, until, vehicleId, smartConnectInfo)
          .then((response) => {
            commit('STATISTICS_RESPONSE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            commit('STATISTICS_ERROR_RESPONSE', error.response)
            reject(error)
          })
      })
    },

    resetStatistics ({ commit }) {
      commit('RESET_STATISTICS')
    }
  },

  getters: {
    getStatistics: state => state.statistics.response,
    getStatisticsStatus: state => state.statistics.status,
    getStatisticsFilters: state => state.statistics.filter,
    getAverageSelection: state => state.averageSelection,
    getDiagramSelections: state => state.diagramSelections,
    getTimelineSelection: state => state.timelineSelection,
  },
}
